import PickupModal from "./PickupModal.container";

export default PickupModal;